import { useMutation } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { decamelizeKeys } from 'humps';
import { USE_QUERY_CONSTANTS } from 'src/constants/constants';
import { ApiRoutes } from '../api/ApiRoutes';
import { useAxios } from '../api/AxiosContext';
import { RatingReservationPayloadProps } from '../api/request';

export const useRateReservationMutation = () => {
  const axios = useAxios();

  const handleEstimate = (payload: RatingReservationPayloadProps) => {
    return axios.post<AxiosResponse<{ message: string }>>(ApiRoutes.rateReservation, decamelizeKeys(payload));
  };

  return useMutation(handleEstimate, {
    cacheTime: USE_QUERY_CONSTANTS.cacheMs,
  });
};
